<template>
  <modal title="Delete Payment Method" size="xs" ref="modal">
    <q-list bordered>
      <payment-method-item :payment-method="paymentMethod"  />
    </q-list>
    <template v-slot:actions>
      <async-btn label="Delete" color="negative" :task="task" @click="remove" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { PaymentMethod, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { remove } from './payment-method';
import PaymentMethodItem from './PaymentMethodItem.vue';

interface Data {
  task: Promise<void>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    PaymentMethodItem,
    AsyncBtn,
  },
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    remove() {
      this.task = remove(this.paymentMethod.id);
      this.task.then(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify('Payment method deleted.');
      });
    },
  },
});
</script>
